import { useSelector } from "react-redux";
import { erc721v4StateSelector } from "./erc721v4Reducer";

export function useV4TokenData() {
    const { tokenData } = useSelector(erc721v4StateSelector);
    return tokenData;
}
